/* 
  Custom js and config
  (jamesanthonyconsulting.com.au)
*/

/* AA - 21/06/24 - Search bar update */
document.addEventListener('DOMContentLoaded', function() {
    var searchBarContainer = document.querySelector('.predictive-search-bar-super-container');
    var searchInput = document.querySelector('.predictive-search-bar-super-container .search__input.field__input');
    var quickSearchButtons = document.querySelectorAll('.thb-quick-search');
    var overlaySearch = document.querySelector('.wrapper-overlay-search');

    quickSearchButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            button.style.opacity = '0';
            setTimeout(function() {
                searchBarContainer.style.display = 'block';
                setTimeout(function() {
                    searchBarContainer.classList.add('search-open');
                    searchInput.focus(); 
                }, 10);
            }, 150);
        });
    });
    overlaySearch.addEventListener('click', function() {
        searchBarContainer.classList.remove('search-open');
        setTimeout(function() {
            searchBarContainer.style.display = 'none';
            quickSearchButtons.forEach(function(button) {
                setTimeout(function() {
                    button.style.opacity = '1';
                }, 10);
            });
        }, 150);
    });
});


